<!-- eslint-disable -->
<template>
<v-form v-model='isValid'>
  <div justify='center'>
    <h3 class='form-header'>
      Inscreva-se grátis para buscar conteúdo imersivo
    </h3>
    <v-text-field
      v-model='email'
      :rules="emailRules"
      error-count="2"
      label='Qual é o seu e-mail?'
      class='mt-2 form-signup'
      hide-details='auto'
      outlined
      dense
    />

    <v-text-field
      v-model='cpf'
      v-mask="'###.###.###-##'"
      :rules="cpfRules"
      error-count="2"
      class='mt-2 form-signup'
      type='text'
      label='CPF'
      hide-details='auto'
      outlined
      dense
    />
    <v-text-field
      v-model='institution'
      :rules="institutionRules"
      label='Qual é o nome de sua instituição?'
      class='mt-2 form-signup'
      hide-details='auto'
      outlined
      dense
      :disabled ='hasQuery'
    />
    <v-text-field
      v-model='password'
      :rules="passwordRules"
      error-count="2"
      label='Crie uma senha'
      class='mt-2 form-signup'
      hide-details='auto'
      :append-icon='showPassword ? mdiEye : mdiEyeOff'
      :type='showPassword ? "text" : "password"'
      outlined
      dense
      @click:append='showPassword = !showPassword'
    />
    <br>
    <v-container>
      <v-row>
        <v-col>
          <v-container
            class='py-0 back-signup'
            fluid
          >
            <span
              @click='closeSignUp()'
            >
              Cancelar
            </span>
          </v-container>
        </v-col>
        <v-col>
          <v-btn
            color='primary'
            :disabled="!isValid"
            @click='handleSignUp()'
          >
            Inscrever-se
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</v-form>
</template>

<script>
import { mdiClose, mdiEye, mdiEyeOff } from '@mdi/js'
import Login from '@/layout/login/index.vue'
import { mask } from 'vue-the-mask'
import { validate } from 'gerador-validador-cpf'
import firebase from '@/api/firebase'

export default {
  name: 'SignUp',
  directives: {
    mask
  },
  data () {
    return {
      isValid: true,
      passwordConfirm: '',
      errorOnRegisterMessage: '',
      mdiClose, mdiEye, mdiEyeOff,
      password: '',
      email: '',
      cpf: '',
      institution: '',
      role: null,
      hasQuery: false,

      signUp: false,
      showPassword: false,

      toastOptions: {
        position: 'bottom-center',
        duration: 3000
      },
      // Ideas about forms, rules and fields validation stolen from this excellent guide:
      //   https://medium.com/js-dojo/form-validation-with-vuetify-in-a-vue-app-d72e3d9b65db
      emailRules: [
        v => !!v || 'Preenchimento do e-mail é necessário',
        v => /.+@.+/.test(v) || 'E-mail precisa ser válido'
      ],
      cpfRules: [
        v => !!v || 'Preenchimento do CPF é necessário',
        v => validate(v) || 'CPF inválido'
      ],
      institutionRules: [
        v => !!v || 'Preenchimento da instituição é necessário',
      ],
      passwordRules: [
        v => !!v || 'Preenchimento da senha é necessário',
        v => (v && v.length >= 6) || 'A senha precisa ter pelo menos 6 caracteres',
        // v => /(?=.*[A-Z])/.test(v) || 'Must have one uppercase character',
        // v => /(?=.*\d)/.test(v) || 'Must have one number',
        // v => /([!@$%])/.test(v) || 'Must have one special character [!@#$%]'
      ],
    }
  },

  async beforeCreate() {
    if(this.$route.query.institution){
      await this.$db.collection('institution').doc(this.$route.query.institution).get()
      .then((doc) => {
        this.institution = doc.data().name.toUpperCase()
        this.role = doc.data().role
        this.hasQuery = true
      })
      .catch((error) => {
        this.$router.push({ name: 'Login' })
        this.$toasted.show('O link para cadastro está incorreto', this.toastOptions)
      })
    }
  },
  
  methods: {
    closeSignUp () {
      this.$router.push({ name: 'Login' })

      // Sets data() to original values, see https://github.com/vuejs/vue/issues/702
      Object.assign(this.$data, this.$options.data())
    },
    handleSignUp () {
      this.$auth.createUserWithEmailAndPassword(this.email, this.password)
        .then(() => {
          try {
            this.$db.collection('user').doc(this.$auth.currentUser.uid).set({
              email: this.email,
              institution: this.institution.toLowerCase(),
              displayname: this.email.split('@')[0],
              created_at:  this.$date,
              role: this.role || 'guest'
            }).then(() => {
              localStorage.setItem('user', JSON.stringify({
                displayName: this.email.split('@')[0],
                email: this.email,
              }))
              this.role = this.role || 'guest'

              this.createGoogleAnalyticsData()

              this.$router.push({ name: 'ContentHome' })
            })
          } catch (error) {
            this.$toasted.show('Ocorreu um erro no cadastro do Firestore', this.toastOptions)
          }
        })
        .catch((error) => {
          var errorOnRegisterMessage = ''
          if (error.code == 'auth/invalid-email') {
            errorOnRegisterMessage = 'O email não está no formato correto'
          }
          else if (error.code == 'auth/weak-password') {
            errorOnRegisterMessage = 'A senha deve conter 6 caracteres ou mais'
          }
          else if (error.code == 'auth/email-already-in-use') {
            errorOnRegisterMessage = 'Esse email já está cadastrado'
          } else {
            errorOnRegisterMessage = 'Ocorreu um erro no registo'
          }
          this.$toasted.show(errorOnRegisterMessage, this.toastOptions)
        })

    },
    async createGoogleAnalyticsData() {
      this.$gtag.event('signup',{
        'event_category': 'User engagement',
        'event_label': 'Institution engagement',
        'institution': this.institution
      })
      this.$gtag.set('user_properties',{
        'institution': this.institution,
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.form-signup {
  width: 500px;
  @media all and (max-width: 768px) {
    width: 100%;
  }
}

.back-signup {
  cursor: pointer;
  text-decoration: underline;
}
</style>
